import { render, staticRenderFns } from "./SecurityForm.vue?vue&type=template&id=07783d5f&"
import script from "./SecurityForm.vue?vue&type=script&lang=js&"
export * from "./SecurityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07783d5f')) {
      api.createRecord('07783d5f', component.options)
    } else {
      api.reload('07783d5f', component.options)
    }
    module.hot.accept("./SecurityForm.vue?vue&type=template&id=07783d5f&", function () {
      api.rerender('07783d5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/SecurityForm.vue"
export default component.exports